import React, { useState } from "react";
import AnimatedDialogLayout from "./AnimatedDialogLayout";
import CustomListDialog from "./CustomListDialog";
import { useOrganiseList } from "context/OrganiseListContext";
import { isObjectEmpty } from "utils/commonUtils";
import useAuth from "hooks/useAuth";
import useDialog from "hooks/useDialog";
import useSubscription from "hooks/useSubscription";
const ChooseAndCreateOrganiseList = ({ isOpen, onClose, onSaveClick }) => {
  const [isOpenListDialog, setIsOpenListDialog] = useState(false);
  const [shakeButton, setShakeButton] = useState(false);
  const {
    organiseLists,
    selectedOrganiseList,
    handleSelectOrganiseList,
    createOrganiseList,
  } = useOrganiseList();
  const { user } = useAuth();
  const { openSigninDialog } = useDialog();
  const { subscriptionStatus } = useSubscription();
  const isPremium = subscriptionStatus.hasPremium;

  // Create new organise list
  const handleOrganiseListAdd = async (list) => {
    try {
      await createOrganiseList(list);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveClick = async () => {
    if (isObjectEmpty(selectedOrganiseList)) {
      setShakeButton(true);
      setTimeout(() => {
        setShakeButton(false);
      }, 5000);
      return;
    }
    await onSaveClick();
    onClose();
  };

  return (
    <>
      <AnimatedDialogLayout
        isOpen={isOpen}
        onClose={() => {
          if (!isOpenListDialog) {
            onClose();
          }
        }}
      >
        <h1 className="text-black font-semibold text-[18px] text-center leading-[21.78px]">
          seleziona una lista
        </h1>
        <div className="mt-[11px] max-h-[190px] overflow-y-auto">
          {organiseLists.map(({ _id, name, emoji, color }) => {
            const isSelected = selectedOrganiseList?._id === _id;

            return (
              <div
                key={_id}
                onClick={() =>
                  handleSelectOrganiseList({ _id, name, color, emoji })
                }
                className=" transition-colors duration-200 ease-in h-[61px] cursor-pointer mb-[10px] rounded-[11px] border border-[#D1D1D1] w-full flex items-center justify-between pl-[19px] pr-[6px] py-[5px]"
                style={{ background: isSelected ? color : "#fff" }}
              >
                <h4
                  className="font-medium text-[20px] leading-[24.2px]"
                  style={{ color: isSelected ? "#fff" : "#000" }}
                >
                  {name}
                </h4>
                <div
                  className="w-[51px] h-[51px] rounded-[7px] grid place-items-center text-3xl"
                  style={{ backgroundColor: color }}
                >
                  {emoji}
                </div>
              </div>
            );
          })}

          <div
            onClick={() =>
              user && isPremium ? setIsOpenListDialog(true) : openSigninDialog()
            }
            className="h-[61px] cursor-pointer rounded-[11px] mb-[10px] border border-[#D1D1D1] w-full flex items-center justify-between pl-[19px] pr-[6px] py-[5px]"
          >
            <h4 className="text-black font-bold text-[20px] leading-[24.2px]">
              Crea una Lista
            </h4>
            <div className="w-[51px] h-[51px] font-bold rounded-[7px] bg-[#EAEAEA] grid place-items-center text-3xl">
              +
            </div>
          </div>
        </div>
        <button
          onClick={handleSaveClick}
          disabled={shakeButton}
          className={`bg-primary disabled:cursor-not-allowed text-white rounded-[11px] h-[51px] w-full grid justify-center items-center font-semibold text-[18px] ${
            shakeButton ? "error-shake" : ""
          }`}
        >
          {shakeButton
            ? "Choose a name"
            : `Salva in ${
                isObjectEmpty(selectedOrganiseList)
                  ? ""
                  : `“${selectedOrganiseList?.name}”`
              }`}
        </button>
      </AnimatedDialogLayout>
      <CustomListDialog
        isOpen={isOpenListDialog}
        onClose={() => setIsOpenListDialog(false)}
        onAdd={handleOrganiseListAdd}
      />
    </>
  );
};

export default ChooseAndCreateOrganiseList;
